export default "__VITE_ASSET__wQ4kKI$K__"